import { Routes, Route } from 'react-router-dom';
import FinancialOverview from './FinancialOverview';
import MonthlyBudget from './MonthlyBudget';
import DataExports from './DataExports';
import DriverPerformance from './DriverPerformance';
import { AccountingHome } from './accounting/AccountingHome';
import { ReportPackList } from './accounting/ReportPackList';
import { ReportPackDetail } from './accounting/ReportPackDetail';
import { useUser } from '../../../../../utils/UserContext';
import { CustomerWithDriverOnboarding } from '../../../../../types/apiTypes';
import dayjs from 'dayjs';

interface CustomerFinancesProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function CustomerFinancesOverview({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: CustomerFinancesProps) {
  const { userId, userRecord } = useUser();
  const customer = userRecord as CustomerWithDriverOnboarding | null;

  const businessType = customer?.business_type ?? null;

  const businessStartDate = customer?.business_start_date;
  const earliestYear = businessStartDate
    ? dayjs(businessStartDate).year()
    : dayjs().year() - 5;

  const props = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
  };
  return (
    <Routes>
      <Route path="/budgeting" element={<MonthlyBudget {...props} />} />
      <Route path="/overview" element={<FinancialOverview {...props} />} />
      <Route path="/data-exports" element={<DataExports {...props} />} />
      <Route
        path="/driver-performance"
        element={<DriverPerformance {...props} />}
      />
      <Route
        path="/accounting"
        element={
          <AccountingHome
            customerId={userId ?? ''}
            businessType={businessType}
            earliestYear={earliestYear}
          />
        }
      />
      <Route path="/accounting/report-packs" element={<ReportPackList />} />
      <Route
        path="/accounting/report-packs/:reportPackId"
        element={<ReportPackDetail />}
      />
    </Routes>
  );
}

export default CustomerFinancesOverview;
